import { type StringifyFilterValue, useStringifyQueryFilters } from '@app/src/hooks/queryState'

import { AssessmentViews } from '@app/src/pages/Assessments/Assessment/assessmentViews'
import { Operators } from '@app/src/pages/ResourceCollection/Filters/useFilters'
import type Assessment from '@app/src/types/assessment'
import paths from '@app/src/wf-constants/paths'
import type { TypographyProps } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import { generatePath } from 'react-router'
import RouterLink from '@app/src/components/RouterLink'
import AssessmentCell from './AssessmentCell'
import ParentCellOrFragment from './ParentCellOrFragment'
import ValueCell from './ValueCell'

const assessmentResultLinkFilters = (assessment: Assessment): StringifyFilterValue[] => [
  { name: 'provider.id', value: [String(assessment.providerId)], operator: Operators.In },
  { name: 'periodName', value: assessment.periodName, operator: Operators.EqualTo },
]

export type AssessmentResultCellProps = {
  assessment?: Assessment
  noPublicData?: boolean
  hideScore?: boolean | false
  disableCell?: boolean
} & TypographyProps

const AssessmentResultCell: React.FC<AssessmentResultCellProps> = ({
  assessment,
  noPublicData,
  hideScore,
  disableCell,
}) => {
  const { formatMessage } = useIntl()
  const { stringifyQueryFilters } = useStringifyQueryFilters()

  const path = generatePath(paths.assessments, {
    view: AssessmentViews.Overview,
    assessmentTemplateId: assessment?.assessmentTemplateId,
  })

  const filters = assessment ? assessmentResultLinkFilters(assessment) : []

  const assessmentLink = stringifyQueryFilters({ url: path, queryParams: { filters } })

  return assessment && !hideScore ? (
    <ParentCellOrFragment disableCell={disableCell}>
      <RouterLink to={assessmentLink}>
        <AssessmentCell
          assessment={assessment}
          disableCell
          noPublicData={noPublicData}
          companyName={assessment?.provider?.name}
        />
      </RouterLink>
    </ParentCellOrFragment>
  ) : (
    <ValueCell
      value={formatMessage({ id: 'schemas.request.notAssessed' })}
      variant="body2"
      color="action.disabled"
      fontSize="1.75rem"
      disableCell={disableCell}
    />
  )
}

export default AssessmentResultCell
